export enum ElementType {
  Timeavtale = 1,
  Henvisning = 2,
}
